<template>
  <div class="tes-card pa-7">
    <h1 class="tes-card__title">{{$t('pages.callBack.title')}}</h1>
    <p class="mt-5 font-weight-medium  mt-4 mb-0"
        :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'">{{$t('client')}}</p>
    <p class="mb-0 mt-5"
      :class="currentLocale === 'ru' ? 'helvetica-roman' : 'rubik-roman'">
          {{$t('pages.callBack.info')}}
    </p>
    <p class="call-back__marker mb-0 mt-5">
      <sup>*</sup> {{$t('pages.callBack.requireFields')}}
    </p>

    <v-form class="call-back__form mt-7" ref="form" v-model="valid" lazy-validation>
      <v-row class="row">
        <v-col cols="12" sm="4" md="3" lg="3" class="cell cell--title">
          {{$t('pages.callBack.phone')}}:
          <sup class="star">*</sup>
        </v-col>
        <v-col class="cell" cols="12" sm="7" md="8" lg="6">
          <v-row>
            <v-col class="cell" cols="12" sm="12" md="6">
              <v-select v-model="phoneType" :disabled="loading" :items="phoneTypes" outlined></v-select>
            </v-col>
            <v-col class="cell" cols="12" sm="12" md="6">
              <v-text-field v-model="phoneNumber"
                            v-mask="phoneMask"
                            :disabled="loading"
                            :rules="phoneNumberRules"
                            outlined></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!--<v-row class="row">
      <v-col cols="12" sm="4" md="3" lg="3" class="cell cell--title">
        Удобная дата для звонка:
        <sup class="star">*</sup>
      </v-col>
      <v-col class="cell" cols="12" sm="7" md="8" lg="6">
        <v-row>
          <v-col class="cell" cols="12" sm="12" md="6">
            <input-date-picker
              :min="minDateTime"
              :max="maxDateTime"
              v-model="date"
              :rules="dateRules"
              :disabled="loading"
            ></input-date-picker>
          </v-col>
          <v-col class="cell" cols="12" sm="12" md="6">
            <v-select v-model="time" :disabled="loading" :items="timeKey" outlined></v-select>
          </v-col>
        </v-row>
      </v-col>
    </v-row>-->

      <p class="tes-orange-text">
        {{$t('pages.callBack.callInfo')}}
      </p>

      <v-row class="row">
        <v-col cols="12" sm="4" md="3" lg="3" class="cell cell--title">
          {{$t('personalAccount')}}:
          <sup class="star">*</sup>
        </v-col>
        <v-col cols="12" sm="7" md="8" lg="6" class="cell cell--lgpan-2">
          <personal-account-select v-model="selectedAccount"
                                   :is-local="true"
                                   :rules="personalAccountSelectRules"
                                   :disabled="loading"></personal-account-select>
        </v-col>
      </v-row>

      <v-row class="row">
        <v-col cols="12" sm="4" md="3" lg="3" class="cell cell--title-top">Комментарий:</v-col>
        <v-col cols="12" sm="7" md="8" lg="6" class="cell cell--lgpan-2">
          <v-textarea v-model="comment" :disabled="loading" outlined></v-textarea>
        </v-col>
      </v-row>

      <v-row class="row">
        <v-col cols="12" sm="4" md="3" lg="3" class="cell cell--title"></v-col>
        <v-col cols="12" sm="7" md="8" lg="6" class="cell cell--lgpan-2">
          <div class="buttons">
            <v-btn class="green-button submit-btn" :class="{'button-font': currentLocale === 'tat'}" :loading="loading" type="submit" @click="submit">{{$t('buttons.post')}}</v-btn>
            <v-btn class="white-button clear-btn" :class="{'button-font': currentLocale === 'tat'}" :loading="loading" @click="clear">{{$t('buttons.cancel')}}</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import InputDatePicker from "../../../components/common/InputDatePicker";
import PersonalAccountSelect from "../../../components/common/PersonalAccountSelect";
import { mask } from "vue-the-mask";
import { mapState, mapGetters } from "vuex";

export default {
  directives: {
    mask
  },
  components: { PersonalAccountSelect, InputDatePicker },
  layout: "main",
  data: () => ({
    minDateTime: new Date().setHours(0, 0, 0, 0),
    maxDateTime: new Date().setFullYear(new Date().getFullYear() + 1),
    phoneType: "Мобильный номер",
    phoneNumber: "",
    selectedAccount: null,
    date: new Date(),
    timeCodes: {
      "Первая половина дня": 802740000,
      "Вторая половина дня": 802740001,
      "Не имеет значения": 802740002
    },
    timeKey: [
      "Первая половина дня",
      "Вторая половина дня",
      "Не имеет значения"
    ],
    time: "Не имеет значения",
    comment: null,
    valid: true,
    dateRules: [v => !!v || "Удобная дата для звонка"],
  }),
  computed: {
    ...mapGetters("locale",["currentLocale"]),
    callTime() {
      return this.timeCodes[this.time];
    },
    callDate() {
      return this.date ? new Date(this.date).getTime() : null;
    },
    phoneMask() {
      return this.phoneType === this.$t('pages.callBack.phoneNumber')
        ? "+7 (###) ###-##-##"
        : "+7##########";
    },
    ...mapState("common", ["loading"]),
    phoneNumberRules() {
      return [
        v => !!v || this.$t('pages.callBack.phoneNumber'),
        v =>  v.length === (this.phoneType === this.$t('pages.callBack.phoneNumber') ? 18 : 12) || this.$t('pages.callBack.phoneCorrect')
      ]
    },
    personalAccountSelectRules(){
        return [v => !!v || this.$t('personalAccount')];
    },
    phoneTypes(){ return [this.$t('pages.callBack.phoneNumber'), this.$t('pages.callBack.cityNumber')]},
  },
  methods: {
    validate() {
      return !!this.$refs.form.validate();
    },
    clear() {
      this.phoneType = this.$t('pages.callBack.phoneNumber');
      this.phoneNumber = "";
      this.selectedAccount = null;
      this.date = new Date();
      this.time = "Не имеет значения";
      this.comment = null;
      this.$refs.form.resetValidation();
    },
    submit(e) {
      e.preventDefault();

      if (!this.validate()) return false;

      this.$store
        .dispatch("feedback/postOrderCallBack", {
          phoneNumber: this.phoneNumber,
          domHoz: this.selectedAccount.domHoz,
          callDate: this.callDate,
          callTime: this.callTime,
          comment: this.comment,
          userId: this.$store.state.account.userSettings.userGuid
        })
        .then(() => {
          this.clear();
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.call-back {
  width: 100%;
  position: relative;
  padding: 23px 17px 23px 22px;
  background: white
    url("../../../assets/img/pages/feedback/call--back/phone.svg") no-repeat
    105% 105%;
  background-size: 50vmin;
  border-radius: 5px;

  &__br {
    display: block;
    font-size: 20px;
  }

  &__title {
    @extend %h1;
  }

  &__important {
    display: block;
    @extend %important-text;
  }

  &__text {
    display: block;
    @extend %text;
    font-style: italic;
  }

  &__marker {
    display: block;
    @extend %marker-text;
  }

  &__form {
    position: relative;
    width: 100%;
  }
}

.cell--title {
  align-self: center;
  margin-bottom: 30px;
}

.cell--title,
.cell--title-top {
  @extend %important-text;
  width: 300px;
}

.cell {
  padding-bottom: 0;
  padding-top: 0;
}

.buttons {
  display: flex;
  @media screen and (max-width: 450px) {
    flex-wrap: wrap;
    justify-content: center;
  }

  .submit-btn {
    margin-right: 7px;
    @media screen and (max-width: 450px) {
      margin-right: 0;
    }
  }

  .clear-btn {
    margin-left: 7px;
    @media screen and (max-width: 450px) {
      margin-top: 10px;
      margin-left: 0;
    }
  }
}

.star {
  color: #ff9933;
}

.button-font{
  font-family: Rubik-Medium !important;
  white-space: normal;
}
</style>
